import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class WhitelabelService {
  private logo$ = new BehaviorSubject<string>(null);
  public logo = this.logo$.asObservable();

  /**
   * This method sets the whitelabel collors of the company or default collors
   * @param colors - company collors
   */
  setColors(colors) {
    colors.forEach(color => {
      if (color.value) {
        color.value = color.value.startsWith('#')
          ? color.value
          : `#${color.value}`;

        document.documentElement.style.setProperty(`--${color.name}`, color.value);
      }
    });
  }

  /**
   * This method sets the logo of the company
   * @param logo -company logo
   */
  setLogo(logo) {
    this.logo$.next(logo);
  }
}